import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Task } from './task';
import { Location } from '../location/location';
import { Bin } from '../location/bin';
import { TaskService } from './task.service';
import {GUILogicService} from '../guilogic.service';

import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.css'],
  providers: [ConfirmationService]
})
export class TaskComponent implements OnInit {

  taskList: Task[];
  msgs: Message[];
  selectedTask: Task;
  areaId: number;
  taskTypeList: SelectItem[];

  dataChartKPI: any;

  constructor(private taskService: TaskService, private router: Router,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private guiLogicService : GUILogicService) {
    this.taskList = [];
    this.msgs = [];
    this.selectedTask = new Task();
    this.selectedTask.bin = new Bin();
    this.selectedTask.sourceLocation = new Location();
    this.selectedTask.destinationLocation = new Location();

    this.dataChartKPI = {
      datasets: [{
        data: [
          5,
          7,
          10,
          6
        ],
        backgroundColor: [
          "#4BC0C0",
          "#FFCE56",
          "#E7E9ED",
          "#36A2EB"
        ],
        label: 'My dataset'
      }],
      labels: [
        "Erledigt",
        "Inarbeit",
        "Angehalten",
        "Freigegeben",
      ]
    }
  }

  ngOnInit() {
    this.loadTasks();
  }

  private loadTasks() {
    console.log('load tasks triggerd');
    this.taskService.list().subscribe(
      (taskArray: Task[]) => {
        console.log('tasks received: ' + JSON.stringify(taskArray));
        this.taskList = [];
        for (var task of taskArray) {
          this.taskList = [...this.taskList, task];
        }
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of tasks.' });
      }
    );
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedTask == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Aufgabe ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/task', this.selectedTask.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedTask == null) {
      this.msgs.push({ severity: 'info', summary: 'Kein Aufgabe ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Möchten Sie den Aufgabe wirlich löschen?',
      accept: () => {
        this.taskService.delete(this.selectedTask.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Aufgabe wurde gelöscht.' });
              this.loadTasks();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Aufgabe konnte nicht gelöscht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Aufgabe konnte nicht gelöscht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited task entity to server.
   */
  public onSave() {
    if (this.selectedTask == null || this.selectedTask.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an task first.' });

    if (this.selectedTask.id == -1) {
      this.taskService.save(this.selectedTask).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Aufgabe wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadTasks();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Aufgabe konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save task, error msg: ' + err);
        }
      );
    }
    else {
      this.taskService.update(this.selectedTask).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Aufgabe wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadTasks();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Aufgabe konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save task, error msg: ' + err);
        }
      );
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task/task.component.ts